import { orpc } from "@/utils/orpc.client";
import type { ViewerLocale } from "@garimpa/lib/viewerPreferences";

export function getArtistHubQueryOptions(locale: ViewerLocale) {
  return orpc.featurePages.getArtistHub.queryOptions({ input: { locale } });
}
